import swaggerClient from "../remote-client";

export default class AddressServiceImpl {
  getRegions() {
    return new Promise((resolve, reject) => {
      swaggerClient.nestCommonSwaggerClient
        .then(function (client) {
          return client.apis.Domain.getRegions(
            {},
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(
          function (result) {
            resolve(result.body);
          },
          function (reason) {
            reject(reason);
          }
        );
    });
  }
  getProvince(commit, regionId) {
    return new Promise((resolve, reject) => {
      swaggerClient.nestCommonSwaggerClient
        .then(function (client) {
          return client.apis.Domain.getProvincesRegionWithId(
            { id: regionId },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(
          function (result) {
            resolve(result.body);
          },
          function (reason) {
            reject(reason);
          }
        );
    });
  }
  getCities(commit, provinceId) {
    return new Promise((resolve, reject) => {
      swaggerClient.nestCommonSwaggerClient
        .then(function (client) {
          return client.apis.Domain.getCitiesProvinceWithId(
            { id: provinceId },
            swaggerClient.buildRequest(),
            {}
          );
        })
        .then(
          function (result) {
            resolve(result.body);
          },
          function (reason) {
            reject(reason);
          }
        );
    });
  }
}
